
    var riot = require('riot')
    //src: starling/src/tags/comments/comments-sidebar.html
riot.tag2('comments-sidebar',
  '<div class="sidebar-header comments-sidebar_header"> <header class="comments-sidebar_top"> <h2 class="comments-sidebar_title">Comments</h2> <div if="{getCommentCount()}" class="pos-rel"> <button class="Button Button--Plain Button--Header" onclick="{toggleFilterMenu}"> <span class="Button__Label">{filter} ({selectedFilterCount()})</span> <svg class="Button__Icon Button__Icon--Caret"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="filterMenu" class="floating-menu floating-menu--small floating-menu--bottom floating-menu--hidden"> <ul class="floating-menu_list"> <li class=" floating-menu_item floating-menu_item--{filter === \'Open\' ? \'active\' : \'iconless\'} {\'floating-menu_item--disabled\': !getOpenCommentCount()} " onclick="{filterComments.bind(this, \'Open\')}"> <svg if="{filter === \'Open\'}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Open ({getOpenCommentCount()})</span> </li> <li class=" floating-menu_item floating-menu_item--{filter === \'Resolved\' ? \'active\' : \'iconless\'} {\'floating-menu_item--disabled\': !getResolvedCommentCount()} " onclick="{filterComments.bind(this, \'Resolved\')}"> <svg if="{filter === \'Resolved\'}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Resolved ({getResolvedCommentCount()})</span> </li> </ul> </div> </div> </header> <div class="comments-sidebar_toggle"> <span class="comments-sidebar_toggle_label"> <label for="comments_checkbox">Display comments</label> <span class="comments-sidebar_toggle_tip" data-tip="Show and hide the visibility of comments on your map." data-tip-align="top"> <svg class="comments-sidebar_toggle_icon"> <use xlink:href="#info-icon"></use> </svg> </span> </span> <switch name="comments" checked="{commentsUI.showComments()}" toggle="{toggleShowComments}"></switch> </div> </div> <div class="comments-scroll-container"> <div if="{!allTopLevelComments().length}" class="comments-sidebar_empty"> <svg class="comments-sidebar_empty_icon"> <use xlink:href="#comment-icon"></use> </svg> <p class="comments-sidebar_empty_message">Leave a note for yourself or share your comments with collaborators.</p> </div> <comment each="{allTopLevelComments(filter)}" instance="{this}" canvas="{canvas}" type="sidebar"></comment> </div> <div class="comments-sidebar_footer"> <new-comment-input if="{canComment()}" target="sidebar" canvas="{canvas}" commentsidebartag="{this}" hidebuttons="{true}"></new-comment-input> </div>',
  '',
  'class="sidebar-content comments-sidebar" onclick="{hideMenus}"', function(opts) {
'use strict';

var _this = this;

var _commentsUi = require('lib/comments-ui');

var _opts = opts,
    canvas = _opts.canvas;

canvas.commentsSidebarTag = this;

this.filter = 'Open';
this.commentTags = {};

this.canComment = function () {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return false;
  return true;
};

this.allTopLevelComments = function (filter) {
  return canvas.store.allTopLevelComments(filter);
};

this.defaultPosition = function () {
  return { x: 1, y: 1 };
};

this.toggleShowComments = function () {
  _commentsUi.commentsUI.toggleShowComments();
};

this.scrollToBottom = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var comments = _this.tags.comment;

  if (comments && comments.length) {
    comments.pop().root.scrollIntoView(options);
  }
};

this.getCommentCount = function () {
  return canvas.store.totalCommentCount();
};

this.getOpenCommentCount = function () {
  return canvas.store.getOpenCommentCount();
};

this.getResolvedCommentCount = function () {
  return canvas.store.getResolvedCommentCount();
};

this.hideMenus = function () {
  _this.hideCommentMenu();
  _this.hideFilterMenu();
};

this.hideCommentMenu = function () {
  var commentMenuTag = canvas.commentMenuTag;

  if (commentMenuTag) {
    commentMenuTag.hide();
  }
};

this.selectedFilterCount = function () {
  switch (_this.filter) {
    case 'Open':
      return _this.getOpenCommentCount();
    case 'Resolved':
      return _this.getResolvedCommentCount();
    default:
      return 0;
  }
};

this.hideFilterMenu = function () {
  var filterMenu = _this.refs.filterMenu;

  if (filterMenu) {
    filterMenu.classList.add('floating-menu--hidden');
  }
};

this.toggleFilterMenu = function (event) {
  var filterMenu = _this.refs.filterMenu;

  event.stopPropagation();
  _this.hideCommentMenu();

  if (filterMenu) {
    filterMenu.classList.toggle('floating-menu--hidden');
  }
};

this.filterComments = function (filter) {
  Object.assign(_this, { filter: filter });
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comments-sidebar')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comments-sidebar.html
// module id = 795
// module chunks = 0